/**
 * Tenant membership is the only direct-login activation boundary.
 * Profile ownership, global roles and tenant-admin metadata are identity or
 * capability projections; none of them may override a suspended membership.
 *
 * @param {{ status?: string | null } | null | undefined} membership
 */
export function hasActiveTenantMembership(membership) {
  return membership?.status === 'active';
}
